import { useUserSelector } from '~/hooks/useUserSelector';
import { RemoteConfigUtils } from '~/utils/RemoteConfigUtils';

/**
 * Whether the employee referral program is disabled for the current user's state.
 *
 * Reads the list of disabled states from the Firebase Remote Config key
 * `EMPLOYEE_REFERRAL_DISABLED_STATES` and checks it against the user's address state.
 */
export const useIsReferralDisabledForState = (): boolean => {
  const user = useUserSelector();
  const disabledStates = RemoteConfigUtils.getEmployeeReferralDisabledStates();

  return !!disabledStates?.includes(user?.address?.[0]?.state);
};
